<template>
  <section id="step-1">
    <template v-if="!cartData.products.length">
      <section id="not-found">
        <h3>{{ $t("empty_cart") }}</h3>
        <a
          :href="productIndex()"
          class="primary-btn"
        >{{
          $t("go_to_products")
        }}</a>
      </section>
    </template>
    <template v-else>
      <h1>{{ $t("Cart") }}</h1>
      <div class="row">
        <Form
          class="col-lg-8"
          @submit="nextStep"
          @invalid-submit="onInvalidSubmit"
        >
          <div class="listing">
            <Loader />
            <Products />
            <OrderServices />
            <div class="summary-price">
              <div
                v-if="discountCoupon"
                class="discount-coupon"
              >
                <span>{{ $t("Discount coupon") }}: "{{
                  discountCoupon.name
                }}"</span>
                <span class="price"> -{{ discountValue }} </span>
              </div>
              <div class="discount-coupon">
                <span>{{ $t("Subtotal") }}</span>
                <span class="price">
                  {{ formattedPrice(subtotalPrice) }}
                </span>
              </div>
              <div class="total">
                <span>{{ $t("Total") }}</span>
                <span class="price">{{ formattedPrice(totalPrice) }}</span>
              </div>
            </div>
            <!-- Mobile -->
            <div class="hidden-md-up">
              <DiscountInput />
            </div>
          </div>
          <div class="pagination">
            <a
              class="prev"
              :href="productLink"
            ><span class="arrow">&#8592;</span>
              {{ $t("Go to product") }}
            </a>
            <button
              type="submit"
              class="next"
            >
              {{ $t('Delivery data') }}
              <span class="arrow">&#8594;</span>
            </button>
          </div>
          <div class="hidden-md-up">
            <FreeShipping />
            <Help />
          </div>
        </Form>
        <!-- Desktop-->
        <div class="col-lg-4 hidden-md-down">
          <DiscountInput />
          <FreeShipping />
          <Help />
        </div>
      </div>
    </template>
  </section>
</template>
<script>
import { Form } from 'vee-validate'
import { useToast } from 'vue-toastification'
import { mapGetters, mapMutations } from 'vuex'
import { scrollToSection } from '../../../../helpers'
import useCart from '../useCart'
import DiscountInput from '../../../packages/views/discount-coupon/Input'
import OrderServices from '../../../packages/views/order-service/Services'
import Products from '../Partials/products/Products'
import useRoutes from '../../../useRoutes'
import Help from '../Partials/Help'
import useOrderService from '../../../packages/views/order-service/useOrderService'
import FreeShipping from '../../../packages/views/free-shipping/FreeShipping.vue'
import Loader from '../../../packages/views/loader/Loader.vue'

export default {
  components: {
    Loader,
    Form,
    Products,
    OrderServices,
    DiscountInput,
    Help,
    FreeShipping,
  },
  computed: {
    ...mapGetters({
      cartData: 'cart/getCartData',
      discountCoupon: 'discountCoupon/getData', // [PACKAGE] - discount coupon
    }),
    discountValue() {
      return this.cartData.discountCoupon
        && this.cartData.discountCoupon.is_percent
        ? `${this.cartData.discountCoupon.value}%`
        : `${this.formattedPrice(this.discountPrice)}`
    },
    subtotalPrice() {
      let price = 0

      price += this.getProductPrice()

      price += this.getOrderServicePrice()

      return price
    },
    totalPrice() {
      let price = this.subtotalPrice

      if (this.discountCoupon) {
        price -= this.discountPrice
      }

      if (price < 0) {
        price = 0
      }

      return price
    },
    productLink() {
      const { products } = this.cartData
      const product = products[products.length - 1]

      return this.productDetail(product.slug)
    },
  },
  methods: {
    ...mapMutations('cart', ['INCREMENT_STEP']),
    onInvalidSubmit({ values, errors, results }) {
      this.toast.error(this.$t('fill_package_text'))

      scrollToSection('#app')
    },
    nextStep() {
      this.setCartLocalStorage()

      this.INCREMENT_STEP()
    },
  },
  mounted() {
    this.updateCartStep(1)
  },
  setup(props) {
    const toast = useToast()
    const {
      formattedPrice,
      discountPrice,
      getProductPrice,
      updateCartStep,
      setCartLocalStorage,
    } = useCart()
    const { productIndex, productDetail } = useRoutes()
    const { getOrderServicePrice } = useOrderService() // [PACKAGE] - order service

    return {
      toast,
      formattedPrice,
      discountPrice,
      getProductPrice,
      getOrderServicePrice,
      updateCartStep,
      productIndex,
      productDetail,
      setCartLocalStorage,
    }
  },
}
</script>
